import React from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import { useMessageHandler } from '../contexts/MessageContext';
import ActionButton from './actionButton';

const ButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '100%',
  width: '100%',
  padding: theme.spacing(0.5),
}));

export default function ActionButtons({ onSend, onUpload, setInputValue, isDisabled }) {

  const { 
    isRecording, 
    startRecording, 
    stopRecording
  } = useMessageHandler();

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    if (files.length > 0) {
      onUpload(files);
    }
    event.target.value = ''; // Reset input
  };

  const handleUploadClick = () => {
    document.getElementById('image-upload-input').click();
  };

  const toggleRecording = async () => {
    if (isRecording) {
      stopRecording((text) => {
        if (text) {
          setInputValue((prev) => prev + text);
        }
      });
    } else {
      startRecording();
    }
  };

  return (
    <ButtonContainer>
      {/* Hidden file input */}
      <input
        accept="image/*,.txt,text/markdown,application/pdf"
        type="file"
        multiple
        onChange={handleFileChange}
        id="image-upload-input"
        disabled={isDisabled }
        style={{ display: 'none' }}
      />

      {/* Send button */}
      <ActionButton
        text="action.send"
        buttonKey="send"
        variant="outlined"
        color="primary"
        onClick={onSend}
        disabled={isDisabled }
        sx={{ flexGrow: 1, marginBottom: 0.5, minHeight: '30px' }}
      />

      {/* Upload button */}
      <ActionButton
        text="action.upload"
        buttonKey="upload"
        variant="outlined"
        color="primary"
        onClick={handleUploadClick}
        disabled={isDisabled }
        sx={{ flexGrow: 1, marginBottom: 0.5, minHeight: '30px' }}
      />

      {/* Record button */}
      <ActionButton
        text={isRecording ? "action.stopRecording" : "action.startRecording"}
        buttonKey={isRecording ? "stopRecord" : "record"}
        variant="outlined"
        color={isRecording ? "error" : "primary"}
        onClick={toggleRecording}
        isClicked={isRecording}
        disabled={isDisabled && !isRecording}
        sx={{ flexGrow: 1, marginBottom: 0.5, minHeight: '30px' }}
      />
    </ButtonContainer>
  );
}
